function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useBus } from "sprout-ui-dom/dist/Bus";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { TeamMemberLevel, useProfilePage_AcceptTeamInviteMutation, useProfilePage_RemoveMemberFromTeamMutation, useProfilePage_RequestToJoinTeamMutation, useProfilePage_SetUserFollowMutation } from "sprout-graphql";
import { Button } from "sprout-ui-dom/dist/Button";
import ActionConfirmationDialog from "@sprout/client-components/dist/Dialog/ActionConfirmationDialog";
import useToggle from "@sprout/hooks/dist/useToggle";
import active from "@sprout/client-lib/dist/active";
const ProfilePageUserHeaderActionButton = (props)=>{
    const { user  } = props;
    const { username , memberLevel , id , teamSettings , amFollowing  } = user;
    const usersCanAskToJoin = teamSettings === null || teamSettings === void 0 ? void 0 : teamSettings.usersCanAskToJoin;
    const currentUser = useCurrentUser();
    const isCurrentUser = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === id;
    const showSnackbar = useSnackbar();
    //
    const [acceptTeamInviteMutation] = useProfilePage_AcceptTeamInviteMutation({
        variables: {
            teamId: id
        }
    });
    const acceptTeamInvite = useCallback(_asyncToGenerator(function*() {
        try {
            yield acceptTeamInviteMutation();
            showSnackbar({
                message: "You have joined the workspace"
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        acceptTeamInviteMutation,
        showSnackbar
    ]);
    //
    const [requestToJoinTeamMutation] = useProfilePage_RequestToJoinTeamMutation({
        variables: {
            teamId: id
        }
    });
    const requestToJoinTeam = useCallback(_asyncToGenerator(function*() {
        try {
            yield requestToJoinTeamMutation();
            showSnackbar({
                message: "You asked to join"
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        requestToJoinTeamMutation,
        showSnackbar
    ]);
    //
    const [removeMemberFromTeamMutation] = useProfilePage_RemoveMemberFromTeamMutation({
        variables: {
            userId: Number(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id),
            teamId: id
        }
    });
    const cancelRequestToJoinTeam = useCallback(_asyncToGenerator(function*() {
        try {
            yield removeMemberFromTeamMutation();
            showSnackbar({
                message: "Request to join cancelled"
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        removeMemberFromTeamMutation,
        showSnackbar
    ]);
    //
    const [leaving, openLeaving, closeLeaving] = useToggle();
    const leaveTeam = useCallback(_asyncToGenerator(function*() {
        if (!leaving) {
            openLeaving();
            return;
        }
        closeLeaving();
        try {
            yield removeMemberFromTeamMutation();
            showSnackbar({
                message: "You have left the workspace"
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        closeLeaving,
        leaving,
        openLeaving,
        removeMemberFromTeamMutation,
        showSnackbar, 
    ]);
    //
    const eventBus = useBus();
    const ignore = user.amFollowing === true ? null : false;
    const [setUserFollowMutation] = useProfilePage_SetUserFollowMutation({
        variables: {
            userId: id,
            ignore
        }
    });
    const setUserFollow = useCallback(_asyncToGenerator(function*() {
        if (!active(currentUser)) {
            eventBus.emit("dialog::auth::open");
            return;
        }
        try {
            yield setUserFollowMutation();
            showSnackbar({
                message: `You ${ignore === false ? "followed" : "unfollowed"} @${username}`
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        currentUser,
        eventBus,
        ignore,
        setUserFollowMutation,
        showSnackbar,
        username, 
    ]);
    if (memberLevel === TeamMemberLevel.Invited) return /*#__PURE__*/ _jsx(Button, {
        variant: "purple",
        onClick: acceptTeamInvite,
        children: "Join"
    });
    else if (usersCanAskToJoin && (memberLevel === null || memberLevel === TeamMemberLevel.Pending)) return /*#__PURE__*/ _jsx(Button, {
        variant: "purple",
        onClick: memberLevel === TeamMemberLevel.Pending ? cancelRequestToJoinTeam : requestToJoinTeam,
        children: memberLevel === TeamMemberLevel.Pending ? "Requested" : "Ask To Join"
    });
    else if (memberLevel === TeamMemberLevel.Admin || memberLevel === TeamMemberLevel.Member) return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "purple",
                onClick: leaveTeam,
                children: "Member"
            }),
            /*#__PURE__*/ _jsx(ActionConfirmationDialog, {
                title: "Leave workspace",
                content: "When you leave a workspace, you will remain a member on all workspace trees you joined.",
                actionText: "Leave",
                onActionClick: closeLeaving,
                open: leaving,
                onRequestClose: closeLeaving
            })
        ]
    });
    else if (memberLevel === TeamMemberLevel.Owner || isCurrentUser) return null;
    else return /*#__PURE__*/ _jsx(Button, {
        variant: "purple",
        onClick: setUserFollow,
        children: amFollowing ? "Following" : "Follow"
    });
};
export default ProfilePageUserHeaderActionButton;
